import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { money } from "utils/helpers";

/**
 * Exports the Product list to a PDF file.
 * @param {Array} listData - array of product rows (same shape as productList?.data?.listData)
 * @param {Object} meta - { tax }
 */
export function exportProductToPdf(listData = [], meta = {}) {
    const { tax = "" } = meta;

    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

    doc.setFontSize(14);
    doc.text("Laporan Product", 40, 40);

    const columns = [
        { header: "No", dataKey: "rowNumber" },
        { header: "Brand", dataKey: "brandName" },
        { header: "Nama Item", dataKey: "productName" },
        { header: "Price", dataKey: "price" },
        { header: "Discount", dataKey: "discount" },
        { header: "Tax", dataKey: "tax" },
        { header: "Final Price", dataKey: "nettPrice" },
        { header: "Status", dataKey: "status" },
    ];

    const rows = listData.map((row, i) => ({
        rowNumber: i + 1,
        brandName: row.brandName,
        productName: row.productName,
        price: `Rp ${money(row.price)}`,
        discount: `${row.discount} %`,
        tax: `${tax} %`,
        nettPrice: `Rp ${money(row.nettPrice)}`,
        status: row.status ? "Active" : "Inactive",
    }));

    autoTable(doc, {
        startY: 58,
        columns,
        body: rows,
        styles: { fontSize: 8, cellPadding: 4 },
        headStyles: { fillColor: [30, 30, 30], textColor: 255 },
    });

    const fileName = `product-list-${new Date().toISOString().slice(0, 10)}.pdf`;
    doc.save(fileName);
}